import React, { useState } from "react";
import "../css/Trivia.css";


const allQuestions = [
  {
    question: "In what year was the Super Bowl first played?",
    options: ["1967", "1970", "1960", "1975"],
    answer: 0,
  },
  {
    question: "What is the most Super Bowl wins any NFL team currently has?",
    options: ["4", "5", "6", "7"],
    answer: 2,
  },
  {
    question: "Which NFL team is nicknamed 'The Steel Curtain'?",
    options: ["Chicago Bears", "Pittsburgh Steelers", "Baltimore Ravens", "Cleveland Browns"],
    answer: 1,
  },
  {
    question: "Who holds the NFL record for most career passing touchdowns?",
    options: ["Tom Brady", "Peyton Manning", "Brett Favre", "Drew Brees"],
    answer: 0,
  },
  {
    question: "Which team plays their home games at Lambeau Field?",
    options: ["Chicago Bears", "Minnesota Vikings", "Green Bay Packers", "Detroit Lions"],
    answer: 2,
  },
  {
    question: "What is the name of the trophy awarded to the Super Bowl winner?",
    options: ["Lombardi Trophy", "Lamar Hunt Trophy", "George Halas Trophy", "Pete Rozelle Trophy"],
    answer: 0,
  },
  {
    question: "Which team is nicknamed 'America's Team'?",
    options: ["New York Giants", "Dallas Cowboys", "Washington Commanders", "Philadelphia Eagles"],
    answer: 1,
  },
  {
    question: "Who was the first pick in the 2023 NFL Draft?",
    options: ["Bryce Young", "CJ Stroud", "Anthony Richardson", "Will Anderson Jr."],
    answer: 0,
  },
  {
    question: "Which city do the Chiefs call home?",
    options: ["St. Louis", "Kansas City", "Oklahoma City", "Denver"],
    answer: 1,
  },
  {
    question: "How many players are on the field per team during a standard NFL play?",
    options: ["10", "12", "11", "9"],
    answer: 2,
  },
  {
    question: "Which defensive player won Super Bowl MVP in Super Bowl LVI?",
    options: ["Aaron Donald", "Cooper Kupp", "Von Miller", "Jalen Ramsey"],
    answer: 1,
  },
  {
    question: "How many rounds are in the NFL Draft?",
    options: ["5", "6", "7", "8"],
    answer: 2,
  },
  {
    question: "Which NFL team has the most consecutive losing seasons in history?",
    options: ["Cleveland Browns", "Detroit Lions", "Tampa Bay Buccaneers", "Cincinnati Bengals"],
    answer: 2,
  },
  {
    question: "What year did the New England Patriots complete their perfect 16-0 regular season?",
    options: ["2005", "2006", "2007", "2008"],
    answer: 2,
  },
  {
    question: "Which wide receiver holds the NFL record for most career receiving yards?",
    options: ["Randy Moss", "Terrell Owens", "Jerry Rice", "Larry Fitzgerald"],
    answer: 2,
  },
  {
    question: "What is the name of the Philadelphia Eagles' home stadium?",
    options: ["MetLife Stadium", "Lincoln Financial Field", "FirstEnergy Stadium", "FedEx Field"],
    answer: 1,
  },
  {
    question: "Which team is nicknamed 'The Monsters of the Midway'?",
    options: ["Green Bay Packers", "Chicago Bears", "Detroit Lions", "Minnesota Vikings"],
    answer: 1,
  },
  {
    question: "Which running back holds the NFL record for most career rushing yards?",
    options: ["Barry Sanders", "Emmitt Smith", "Walter Payton", "LaDainian Tomlinson"],
    answer: 1,
  },
];

function getRandomQuestions(arr, n) {
  const shuffled = arr.slice().sort(() => 0.5 - Math.random());
  return shuffled.slice(0, n);
}


function FootballTrivia() {
  const [questions, setQuestions] = useState(() => getRandomQuestions(allQuestions, 5));
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0);
  const [showScore, setShowScore] = useState(false);
  const [playCount, setPlayCount] = useState(() => {
    const stored = localStorage.getItem('footballTriviaPlayCount');
    return stored ? parseInt(stored, 10) : 0;
  });
  const [lastScore, setLastScore] = useState(() => {
    const stored = localStorage.getItem('footballTriviaLastScore');
    return stored ? parseInt(stored, 10) : 0;
  });

  const handleOptionClick = (idx) => {
    setSelected(idx);
  };

  const handleNext = () => {
    if (selected === questions[current].answer) {
      setScore(score + 1);
    }
    setSelected(null);
    if (current < questions.length - 1) {
      setCurrent(current + 1);
    } else {
      // End of quiz: update play count and last score in localStorage
      const newPlayCount = playCount + 1;
      localStorage.setItem('footballTriviaPlayCount', newPlayCount);
      localStorage.setItem('footballTriviaLastScore', selected === questions[current].answer ? score + 1 : score);
      setPlayCount(newPlayCount);
      setLastScore(selected === questions[current].answer ? score + 1 : score);
      setShowScore(true);
    }
  };

  const handleRestart = () => {
    setQuestions(getRandomQuestions(allQuestions, 5));
    setCurrent(0);
    setSelected(null);
    setScore(0);
    setShowScore(false);
  };

  return (
    <div className="trivia-card">
      <h2>NFL Trivia</h2>
      {showScore ? (
        <div>
          <h3>Your score: {lastScore} / {questions.length}</h3>
          <p>You have played {playCount} {playCount === 1 ? 'time' : 'times'}.</p>
          <button className="trivia-next-btn" onClick={handleRestart}>Play Again</button>
        </div>
      ) : (
        <div>
          <h4>Question {current + 1} of {questions.length}</h4>
          <p>{questions[current].question}</p>
          <div className="trivia-options">
            {questions[current].options.map((opt, idx) => (
              <button
                key={idx}
                onClick={() => handleOptionClick(idx)}
                className={"trivia-option-btn" + (selected === idx ? " selected" : "")}
              >
                {opt}
              </button>
            ))}
          </div>
          <button
            className="trivia-next-btn"
            onClick={handleNext}
            disabled={selected === null}
          >
            {current === questions.length - 1 ? "Finish" : "Next"}
          </button>
        </div>
      )}
    </div>
  );
}

export default FootballTrivia;
